import { render, staticRenderFns } from "./StepInfoTeleconsulta.vue?vue&type=template&id=25c5267a"
import script from "./StepInfoTeleconsulta.vue?vue&type=script&lang=js"
export * from "./StepInfoTeleconsulta.vue?vue&type=script&lang=js"
import style0 from "./StepInfoTeleconsulta.vue?vue&type=style&index=0&id=25c5267a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports